// export * from './components/common/AuthBanner';
export { AutoCompleteField } from './components/common/AutoCompleteField';
export { CancelButton, SolidCancelButton } from './components/common/CancelButton';
// export * from './components/common/CodeEditor';
export { CreateButton } from './components/common/CreateButton';
export { DropzonePlaceholder } from './components/common/DropzonePlaceholder';
export { DropzoneUpload } from './components/common/DropzoneUpload';
// export * from './components/common/FilterComponent';
export { HeaderDynamicTitles } from './components/common/HeaderDynamicTitles';
// export * from './components/common/MarkdownViewer';
export { MultipleSelectAutoCompleteField } from './components/common/MultipleSelectAutoCompleteField';
export { SingleSelectAutoCompleteField } from './components/common/SingleSelectAutoCompleteField';
export { SocialMediaLogin } from './components/common/SocialMediaLogin';
export { BackButton } from './components/common/BackButton';
export { FileReaderExt } from './components/common/FileReaderExt';
export { NotFound } from './components/common/NotFound';

import Error from './components/common/error';
export { Error };

export { SolidFormStepper } from './components/common/SolidFormStepper';
export { SolidViewLayoutManager } from './components/core/common/SolidViewLayoutManager';

// export { SolidListViewOptions } from './components/core/common/SolidListViewOptions';
export { SolidListViewConfigure } from './components/core/list/SolidListViewConfigure';
export { SolidCreateButton } from './components/core/common/SolidCreateButton';
export { SolidGlobalSearchElement } from './components/core/common/SolidGlobalSearchElement';
export { SolidSaveCustomFilterForm } from './components/core/common/SolidSaveCustomFilterForm';
export { SolidSearchBox } from './components/core/common/SolidSearchBox';

// export type {ModelMetaData} from './components/core/field/FieldListViewData';
export { FieldListViewData } from './components/core/field/FieldListViewData';

export type { SolidFormViewProps } from './components/core/form/SolidFormView';

export type { FormikObject, ISolidField, SolidFieldProps } from './components/core/form/fields/ISolidField';
export { SolidBooleanField } from './components/core/form/fields/SolidBooleanField';
export { SolidDateField } from './components/core/form/fields/SolidDateField';
export { SolidDateTimeField } from './components/core/form/fields/SolidDateTimeField';
export { SolidDecimalField } from './components/core/form/fields/SolidDecimalField';
export { SolidIntegerField } from './components/core/form/fields/SolidIntegerField';
export { SolidJsonField } from './components/core/form/fields/SolidJsonField';
export { SolidLongTextField } from './components/core/form/fields/SolidLongTextField';
export { SolidMediaMultipleField } from './components/core/form/fields/SolidMediaMultipleField';
export { SolidMediaSingleField } from './components/core/form/fields/SolidMediaSingleField';
export { SolidRelationField } from './components/core/form/fields/SolidRelationField';
export { SolidRichTextField } from './components/core/form/fields/SolidRichTextField';
export { SolidSelectionDynamicField } from './components/core/form/fields/SolidSelectionDynamicField';
export { SolidSelectionStaticField } from './components/core/form/fields/SolidSelectionStaticField';
export { SolidShortTextField } from './components/core/form/fields/SolidShortTextField';
export { SolidTimeField } from './components/core/form/fields/SolidTimeField';

export { SolidRelationManyToManyField } from './components/core/form/fields/relations/SolidRelationManyToManyField';
export { SolidRelationManyToOneField } from './components/core/form/fields/relations/SolidRelationManyToOneField';
export { SolidRelationOneToManyField } from './components/core/form/fields/relations/SolidRelationOneToManyField';

export { SolidChatter } from './components/core/chatter/SolidChatter';

// export * from './components/core/kanban/KanbanBoard';
// export * from './components/core/kanban/KanbanCard';
// export * from './components/core/kanban/KanbanColumn';
export { SolidKanbanView } from './components/core/kanban/SolidKanbanView';

export { SolidModuleHome } from './components/common/SolidModuleHome';
export { SolidListView } from './components/core/list/SolidListView';
export { SolidListViewColumn, getNumberOfInputs } from './components/core/list/SolidListViewColumn';
export type { SolidListViewColumnParams } from './components/core/list/SolidListViewColumn';

// export * from './components/core/list/SolidListingHeader';
export { SolidManyToOneFilterElement } from './components/core/list/SolidManyToOneFilterElement';
export { SolidSelectionDynamicFilterElement } from './components/core/list/SolidSelectionDynamicFilterElement';
export { SolidSelectionStaticFilterElement } from './components/core/list/SolidSelectionStaticFilterElement';
export { SolidVarInputsFilterElement } from './components/core/list/SolidVarInputsFilterElement';

export { default as SolidDashboard } from './components/core/dashboard/SolidDashboard';

export { dateFilterMatchModeOptions } from './components/core/list/columns/SolidDateColumn';

export { ModelListViewData } from './components/core/model/ModelListViewData';
export { ModuleListViewData } from './components/core/module/ModuleListViewData';

export { UserListView } from './components/core/users/UserListView';

export { GlobalSearch } from './components/layout/GlobalSearch';
export { LayoutContext, LayoutProvider } from './components/layout/context/layoutcontext';
export { Layout } from './components/layout/Layout';

export { FilterIcon } from './components/modelsComponents/filterIcon';

export { ToastContainer, handleError, handleSuccess } from './helpers/ToastContainer';
// export { getAuthCookieName, getAuthHeader } from './helpers/authHeader';
export { AppTitle } from './helpers/AppTitle';
export { addCommasToAmount, calculateDaysOfStay, getSingularAndPlural } from './helpers/helpers';
export { permissionExpression } from './helpers/permissions';
export { revalidateTag } from './helpers/revalidate';
export { useHasAllRoles, useHasAnyRole, hasAnyRole } from './helpers/rolesHelper';
export { registerExtensionComponent, registerExtensionFunction } from './helpers/registry';

export {
    authApi,
    useForgotPasswordMutation,
    useRegisterMutation,
    useRegisterPrivateMutation,
    useResetPasswordMutation,
    useUpdateUserMutation,
    useInitateLoginMutation,
    useConfirmOtpLoginMutation,
    useInitateRegisterMutation,
    useConfirmOtpRegisterMutation
} from './redux/api/authApi';

export { baseQueryWithAuth } from './redux/api/fetchBaseQuery';

export {
    fieldsApi,
    useCreatefieldMutation,
    useDeletefieldMutation,
    useGetFieldDefaultMetaDataQuery,
    useGetSelectionDynamicValueQuery,
    useGetSelectionDynamicValuesQuery,
    useGetfieldByIdQuery,
    useGetfieldsQuery,
    useLazyGetFieldDefaultMetaDataQuery,
    useLazyGetSelectionDynamicValueQuery,
    useLazyGetSelectionDynamicValuesQuery,
    useLazyGetfieldByIdQuery,
    useLazyGetfieldsQuery
} from './redux/api/fieldApi';

export {
    mediaApi,
    useCreateMediaMutation,
    useDeleteMediaMutation,
    useDeleteMultipleMediasMutation,
    useGetMediaByIdQuery,
    useGetMediasQuery,
    useLazyGetMediaByIdQuery,
    useLazyGetMediasQuery,
    useUpdateMediaMutation
} from './redux/api/mediaApi';

export {
    mediaStorageProviderApi,
    useCreateMediaStorageProivderMutation,
    useDeleteMediaStorageProivderMutation,
    useDeleteMultipleMediaStorageProvidersMutation,
    useGetMediaStorageProivderByIdQuery,
    useGetMediaStorageProvidersQuery,
    useLazyGetMediaStorageProivderByIdQuery,
    useLazyGetMediaStorageProvidersQuery,
    useUpdateMediaStorageProivderMutation
} from './redux/api/mediaStorageProviderApi';

export {
    modelsApi,
    useCreatemodelMutation,
    useDeleteMultipleModelsMutation,
    useDeletemodelMutation,
    useGenerateCodeForModelMutation,
    useGetModelsQuery,
    useGetmodelByIdQuery,
    useLazyGetModelsQuery,
    useLazyGetmodelByIdQuery,
    useUpdatemodelMutation
} from './redux/api/modelApi';

export {
    modulesApi,
    useCreatemoduleMutation,
    useDeleteMultiplemodulesMutation,
    useDeletemoduleMutation,
    useGenerateCodeFormoduleMutation,
    useGetDefaultDataSourceQuery,
    useGetmoduleByIdQuery,
    useGetmodulesQuery,
    useLazyGetDefaultDataSourceQuery,
    useLazyGetmoduleByIdQuery,
    useLazyGetmodulesQuery,
    useRefreshPermissionsMutation,
    useUpdatemoduleMutation
} from './redux/api/moduleApi';

export { solidServiceApi, useSeederMutation } from './redux/api/solidServiceApi';
export { solidChatterMessageApi, useGetchatterMessageQuery, useLazyGetchatterMessageQuery } from './redux/api/solidChatterMessageApi';

export {
    roleApi,
    useGetrolesQuery,
    useGetroleByIdQuery,
    useCreateroleMutation,
    useLazyGetrolesQuery,
    useUpdateroleMutation,
    useDeleteroleMutation
} from './redux/api/roleApi';

export {
    exportTemplateApi,
    useCreateExportTemplateMutation,
    useGetExportTemplatesQuery,
    useCreateExportSyncMutation,
    useCreateExportAsyncMutation
} from './redux/api/exportTemplateApi';

export {
    importTransactionApi,
    useGetImportInstructionsQuery,
    useLazyGetImportInstructionsQuery,
    useGetImportTemplateQuery,
    useLazyGetImportTemplateQuery,
    useCreateImportTransactionMutation,
    usePatchUpdateImportTransactionMutation,
    useGetImportMappingInfoQuery,
    useLazyGetImportMappingInfoQuery,
    useCreateImportAsyncMutation,
    useCreateImportSyncMutation
} from './redux/api/importTransactionApi';

export {
    solidActionsApi,
    useCreateSolidActionMutation,
    useDeleteMultipleSolidActionsMutation,
    useDeleteSolidActionMutation,
    useGetSolidActionByIdQuery,
    useGetSolidActionsQuery,
    useLazyGetSolidActionByIdQuery,
    useLazyGetSolidActionsQuery,
    useUpdateSolidActionMutation
} from './redux/api/solidActionApi';

export { createSolidEntityApi } from './redux/api/solidEntityApi';

export {
    solidMenusApi,
    useCreateSolidMenuMutation,
    useDeleteMultipleSolidMenusMutation,
    useDeleteSolidMenuMutation,
    useGetSolidMenuBasedOnRoleQuery,
    useGetSolidMenuByIdQuery,
    useGetSolidMenusQuery,
    useLazyGetSolidMenuBasedOnRoleQuery,
    useLazyGetSolidMenuByIdQuery,
    useLazyGetSolidMenusQuery,
    useUpdateSolidMenuMutation
} from './redux/api/solidMenuApi';

export {
    solidViewsApi,
    useCreateSolidViewMutation,
    useDeleteMultipleSolidViewsMutation,
    useDeleteSolidViewMutation,
    useGetSolidViewByIdQuery,
    useGetSolidViewLayoutQuery,
    useGetSolidViewsQuery,
    useLazyGetSolidViewByIdQuery,
    useLazyGetSolidViewsQuery,
    useUpdateSolidViewMutation
} from './redux/api/solidViewApi';

export { dashboardApi } from './redux/api/dashboardApi';
export { dashboardQuestionApi } from './redux/api/dashboardQuestionApi';
export { aiInteractionApi } from './redux/api/aiInteractionApi';

export {
    useCreateuserroleMutation,
    useCreateuserrolebulkMutation,
    useDeleteMultipleUsersMutation,
    useDeleteUserMutation,
    useGetusersByIdQuery,
    useGetusersQuery,
    useLazyCheckIfPermissionExistsQuery,
    useLazyGetusersByIdQuery,
    useLazyGetusersQuery,
    useLazyUpdateSessionQuery,
    useRegisterUserMutation,
    useUpdatePasswordMutation,
    useUpdateProfileMutation,
    useUpdateSessionQuery,
    useUploadAvatarMutation,
    userApi
} from './redux/api/userApi';

export {
    solidSettingsApi,
    useCreateSolidSettingsMutation,
    useGetSolidSettingsByIdQuery,
    useGetSolidSettingsQuery,
    useGetAuthSettingsQuery,
    useLazyGetAuthSettingsQuery,
    useLazyGetSolidSettingsQuery,
    useLazyGetSolidSettingsByIdQuery,
    useUpdateSolidSettingsMutation
} from './redux/api/solidSettingsApi';

export { logout, setToken } from './redux/features/authSlice';
export { gridView, listView } from './redux/features/dataViewSlice';
export { hideNavbar, showNavbar, toggleNavbar } from './redux/features/navbarSlice';
export { toggleTheme } from './redux/features/themeSlice';
export { setIsAuthenticated, setUser } from './redux/features/userSlice';

// Admin Parent Layout
export { AdminLayout } from './components/layout/AdminLayout';
export { SolidAdmin } from './components/common/SolidAdmin';

// Re-export default exports
export { default as AuthBanner } from './components/common/AuthBanner';
export { default as CodeEditor } from './components/common/CodeEditor';
export { default as MarkdownViewer } from './components/common/MarkdownViewer';

export { default as SolidFormLayouts } from './components/core/form/SolidFormLayouts';
export { default as SolidFormView } from './components/core/form/SolidFormView';
export { default as KanbanBoard } from './components/core/kanban/KanbanBoard';
export { default as KanbanCard } from './components/core/kanban/KanbanCard';
export { default as KanbanColumn } from './components/core/kanban/KanbanColumn';
export { default as SolidListingHeader } from './components/core/list/SolidListingHeader';
export { default as SolidBigintColumn } from './components/core/list/columns/SolidBigintColumn';
export { default as SolidBooleanColumn } from './components/core/list/columns/SolidBooleanColumn';
export { default as SolidComputedColumn } from './components/core/list/columns/SolidComputedColumn';
export { default as SolidDateColumn } from './components/core/list/columns/SolidDateColumn';
export { default as SolidDatetimeColumn } from './components/core/list/columns/SolidDatetimeColumn';
export { default as SolidDecimalColumn } from './components/core/list/columns/SolidDecimalColumn';
export { default as SolidExternalIdColumn } from './components/core/list/columns/SolidExternalIdColumn';
export { default as SolidFloatColumn } from './components/core/list/columns/SolidFloatColumn';
export { default as SolidIdColumn } from './components/core/list/columns/SolidIdColumn';
export { default as SolidIntColumn } from './components/core/list/columns/SolidIntColumn';
export { default as SolidLongTextColumn } from './components/core/list/columns/SolidLongTextColumn';
export { default as SolidMediaMultipleColumn } from './components/core/list/columns/SolidMediaMultipleColumn';
export { default as SolidMediaSingleColumn } from './components/core/list/columns/SolidMediaSingleColumn';
export { default as SolidRelationColumn } from './components/core/list/columns/SolidRelationColumn';
export { default as SolidRichTextColumn } from './components/core/list/columns/SolidRichTextColumn';
export { default as SolidSelectionDynamicColumn } from './components/core/list/columns/SolidSelectionDynamicColumn';
export { default as SolidSelectionStaticColumn } from './components/core/list/columns/SolidSelectionStaticColumn';
export { default as SolidShortTextColumn } from './components/core/list/columns/SolidShortTextColumn';
export { default as SolidTimeColumn } from './components/core/list/columns/SolidTimeColumn';
export { default as SolidUuidColumn } from './components/core/list/columns/SolidUuidColumn';
export { default as SolidRelationManyToOneColumn } from './components/core/list/columns/relations/SolidRelationManyToOneColumn';

export { default as CreateModel } from './components/core/model/CreateModel';
export { default as FieldMetaData } from './components/core/model/FieldMetaData';
export { default as FieldMetaDataForm } from './components/core/model/FieldMetaDataForm';
export { default as FieldSelector } from './components/core/model/FieldSelector';
export { default as ModelMetaData } from './components/core/model/ModelMetaData';

export { default as CreateModule } from './components/core/module/CreateModule';

export { default as CreateUser } from './components/core/users/CreateUser';
export { default as CreateUserRole } from './components/core/users/CreateUserRole';

export { default as AdminSidebar } from './components/layout/AdminSidebar';
export { default as ButtonLoader } from './components/layout/ButtonLoader';
export { default as DashboardHeader } from './components/layout/DashboardHeader';
export { default as FilterMenu } from './components/layout/FilterMenu';
export { default as Footer } from './components/layout/Footer';
export { default as Header } from './components/layout/Header';
export { default as ListingHeader } from './components/layout/ListingHeader';
export { default as Loader } from './components/layout/Loader';
export { default as NavbarOne } from './components/layout/navbar-one';
export { default as NavbarTwoMenu } from './components/layout/navbar-two-menu';
export { default as NavbarTwo } from './components/layout/navbar-two';
export { default as UserProfileMenu } from './components/layout/user-profile-menu';
export { default as UserProfile } from './components/layout/user-profile';
export { default as UserSidebar } from './components/layout/UserSidebar';
export { default as SolidPopupContainer } from './components/common/SolidPopupContainer';

// Auth
export { AuthLayout } from './components/auth/AuthLayout';
export { default as SolidForgotPassword } from './components/auth/SolidForgotPassword';
export { default as SolidLogin } from './components/auth/SolidLogin';
export { default as SolidOTPVerify } from './components/auth/SolidOTPVerify';
export { default as SolidRegister } from './components/auth/SolidRegister';
export { default as SolidResetPassword } from './components/auth/SolidResetPassword';
export { default as SolidChangeForcePassword } from './components/auth/SolidChangeForcePassword';
export { default as SolidInitialLoginOtp } from './components/auth/SolidInitialLoginOtp';
export { default as SolidInitiateRegisterOtp } from './components/auth/SolidInitiateRegisterOtp';
export { GoogleAuthChecking } from './components/auth/GoogleAuthChecking';
export { ForgotPasswordThankYou } from './components/auth/ForgotPasswordThankYou';

// redux
export { default as authenticationReducer } from './redux/features/authSlice';
export { default as dataViewReducer } from './redux/features/dataViewSlice';
export { default as navbarReducer } from './redux/features/navbarSlice';
export { default as popupReducer } from './redux/features/popupSlice';
export { closePopup, openPopup } from './redux/features/popupSlice';
export { default as themeReducer } from './redux/features/themeSlice';
export { default as userReducer } from './redux/features/userSlice';
export { default as settingsReducer } from './redux/features/settingsSlice';
export { default as useSolidPopup } from './redux/hooks/useSolidPopup';
export { solidApiSlices, solidReducers } from './redux/store/defaultStoreConfig';

export { default as GenerateModelCodeRowAction } from './components/core/extension/solid-core/modelMetadata/list/GenerateModelCodeRowAction';

// types
export type {
    LayoutConfig,
    CommonEntity,
    ModelMetadata,
    ModuleMetadata,
    FieldMetadata,
    FieldsMetadata,
    SolidView,
    LayoutAttribute,
    LayoutNode,
    LayoutNodeType,
    SolidUiEvents,
    SolidUiEvent,
    SolidUiEventResponse,
    SolidLoadList,
    SolidListUiEventResponse,
    SolidListUiEvent,
    SolidLoadForm,
    SolidFormWidgetProps,
    SolidFormFieldWidgetProps,
    SolidChartRendererProps,
    SolidBeforeListDataLoad
} from './types';

export { GeneralSettings } from './components/common/GeneralSettings';

export { default as authProviders } from './nextAuth/authProviders';
export { SolidThemeLink } from './components/common/SolidThemeLink';
export { SolidThemeProvider } from './components/common/SolidThemeProvider';

export * from "./styles";
